import React, { Component } from 'react';
import {
    Button, FormGroup, ControlLabel, Modal, Table, Row, Col, FormControl
} from 'react-bootstrap';
import { SketchPicker } from 'react-color';
import { TableButton } from '../../../TableButton';

export class LineColorShades extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingIndex: null,
            currentColor: '',
            isAdding: false,
            generateShades: 'claras',
            pendingGenerateShades: null,
            showGenerateConfirmationModal: false
        };
    }

    hexFromVal(val) {
        if (!val) return '';
        const toHex = (v) => v.toString(16).padStart(2, '0');
        return `#${toHex(val.r)}${toHex(val.g)}${toHex(val.b)}`;
    }

    hexToRgb(hex) {
        if (!hex) return null;
        const bigint = parseInt(hex.replace(/^#/, ''), 16);
        return {
            r: (bigint >> 16) & 255,
            g: (bigint >> 8) & 255,
            b: bigint & 255,
            a: 1
        };
    }

    handleStartEdit = (index, color) => {
        const shade = this.props.lineColorSelected.shades[index];
        const currentColor = shade.color ? this.hexToRgb(shade.color) : shade.val;
        this.setState({ editingIndex: index, currentColor });
    };

    handleColorChange = (color) => {
        this.setState({ currentColor: color.rgb });
    };

    handleSaveEdit = () => {
        const { editingIndex, currentColor, isAdding } = this.state;
        if (editingIndex !== null) {
            if (isAdding) {
                const newShade = { seq: editingIndex, val: currentColor };
                this.props.onCreateShadeValue(newShade);
            } else {
                this.props.onEditShadeValue(currentColor, editingIndex);
            }
            this.setState({ editingIndex: null, currentColor: '', isAdding: false });
        }
    };

    handleCancelEdit = () => {
        this.setState({ editingIndex: null, currentColor: '', isAdding: false });
    };

    handleAddNew = () => {
        this.setState({
            editingIndex: this.props.lineColorSelected.shades.length,
            currentColor: { r: 255, g: 255, b: 255, a: 1 },
            isAdding: true,
        });
    };

    handleGenerateClick = () => {
        const { lineColorSelected } = this.props;
        const { generateShades } = this.state;

        lineColorSelected.shades = [];

        const { r, g, b } = lineColorSelected.backColor;
        const deltaR = generateShades === 'claras' ? 255 - r : r;
        const deltaG = generateShades === 'claras' ? 255 - g : g;
        const deltaB = generateShades === 'claras' ? 255 - b : b;

        for (let i = 10, z = 0; i <= 50; i += 10, z++) {
            const newShade = {
                seq: z,
                val: {
                    r: Math.round(r + (generateShades === 'claras' ? deltaR : -deltaR) * i / 100),
                    g: Math.round(g + (generateShades === 'claras' ? deltaG : -deltaG) * i / 100),
                    b: Math.round(b + (generateShades === 'claras' ? deltaB : -deltaB) * i / 100),
                    a: 1
                }
            };
            this.props.onCreateShadeValue(newShade);
        }
    };

    confirmGenerate = () => {
        this.setState(
            {
                generateShades: this.state.pendingGenerateShades,
                pendingGenerateShades: null,
                showGenerateConfirmationModal: false
            },
            this.handleGenerateClick
        );
    };
showGenerateConfirmationModal
    cancelGenerate = () => {
        this.setState({
            pendingGenerateShades: null,
            showGenerateConfirmationModal: false
        });
    };

    getConfirmation = () => (
        <Modal
            show={this.state.showGenerateConfirmationModal}
            onHide={() => this.setState({ showGenerateConfirmationModal: false })}
            dialogClassName="confirmation-modal-dialog"
            centered
        >
            <Modal.Header className="modal-warning-header">
                <Modal.Title>
                    <h3 className="alert-title">
                        <i className="icon-alert" />&nbsp;&nbsp; Aviso
                    </h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Todas as tonalidades existentes serão substituídas. Deseja continuar?
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.confirmGenerate}>SIM</Button>
                <Button onClick={this.cancelGenerate}>NÃO</Button>
            </Modal.Footer>
        </Modal>
    );


    render() {
        const {
            show,
            onHide,
            onRemoveShadeValue,
        } = this.props;

        const {
            editingIndex,
            currentColor,
            isAdding,
        } = this.state;

        const shades = this.props.lineColorSelected && this.props.lineColorSelected.shades ? this.props.lineColorSelected.shades : [];
        return (
            <Modal show={show} onHide={onHide} dialogClassName="large-modal">
                <Modal.Header>
                    <Modal.Title>Gerir Tonalidades</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: '450px', overflowY: 'auto' }}>
                    <FormGroup>
                        <Row>
                            <FormGroup controlId="formGerarAutomaticamente">
                                <div style={{
                                    paddingLeft: '15px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                }}>
                                    <ControlLabel style={{ alignSelf: 'flex-end', lineHeight: '30px' }}>
                                        Gerar Automaticamente
                                    </ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        style={{ width: 'auto', minWidth: '150px', alignSelf: 'flex-start', paddingTop: '5px' }}
                                        value={this.state.pendingGenerateShades || ""}
                                        onChange={(e) => this.setState({
                                            pendingGenerateShades: e.target.value,
                                            showGenerateConfirmationModal: true
                                        })}
                                    >
                                        <option value="" disabled hidden>Selecionar opção</option>
                                        <option value="claras">Tonalidades claras</option>
                                        <option value="escuras">Tonalidades escuras</option>
                                    </FormControl>
                                </div>
                            </FormGroup>
                        </Row>
                    </FormGroup>

                    <Row>
                        <Col
                            md={6}
                            style={{ paddingRight: '20px' }}
                        >
                            <h5 style={{ fontWeight: 'bold' }}>TONALIDADES</h5>
                            <Table striped bordered condensed hover>
                                <thead>
                                    <tr>
                                        <th style={{ width: '10%', textAlign: 'center' }}>#</th>
                                        <th style={{ width: '20%', textAlign: 'center' }}>Hex </th>
                                        <th style={{ width: '15%', textAlign: 'center' }}>Cor</th>
                                        <th style={{ width: '25%', textAlign: 'center' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {shades.map((shade, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                {shade.color || this.hexFromVal(shade.val).toUpperCase()}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div
                                                    className="span-colors"
                                                    style={{
                                                        backgroundColor: shade.color || this.hexFromVal(shade.val)
                                                    }}
                                                />
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <TableButton
                                                    icon="icon-edit"
                                                    title="Editar"
                                                    marginRight
                                                    onClick={() => this.handleStartEdit(index, shade.color)}
                                                />
                                                <TableButton
                                                    icon="icon-trash"
                                                    title="Eliminar"
                                                    bsStyle="danger"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onRemoveShadeValue(index);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <Button
                                className="pull-right"
                                onClick={this.handleAddNew}
                                disabled={shades.length >= 5}
                            >
                            ADICIONAR
                            </Button>
                        </Col>

                        <Col md={6}
                            style={{ borderLeft: '1px solid #ccc', paddingLeft: '20px' , display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}
                        >
                            {(editingIndex !== null || isAdding) && (
                                <div style={{ marginTop: 0, width: '100%' }}>
                                    <ControlLabel className="h5" style={{ margin: 0, fontWeight: 'bold', paddingTop: '10px', paddingBottom: '10px' }}>
                                        {isAdding
                                            ? `Nova Tonalidade #${editingIndex + 1}`
                                            : `Editar Tonalidade #${editingIndex + 1}`}
                                    </ControlLabel>
                                    <SketchPicker color={currentColor} onChange={this.handleColorChange} />
                                    <div style={{ marginTop: 10 }}>
                                        <Button onClick={this.handleSaveEdit}>CONFIRMAR</Button>{' '}
                                        <Button onClick={this.handleCancelEdit}>CANCELAR</Button>
                                    </div>
                                </div>
                            )}

                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <div className="pull-left">
                        <Button onClick={this.props.onSaveShades}>GUARDAR</Button>
                        <Button onClick={onHide}>CANCELAR</Button>
                    </div>
                </Modal.Footer>
                {this.getConfirmation()}
            </Modal>
        );
    }
}
